import { useParams } from '@tanstack/react-router';

/**
 * The import the wizard is on.
 *
 * `strict: false` because every wizard step reads it from its own route, and a matcher tied to
 * one of them would not resolve from the others.
 */
export function useImportId(): string {
  const { importId } = useParams({ strict: false });
  return importId ?? '';
}
